import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from './ui/card';
import { Badge } from './ui/badge';

const ResultsSection = () => {
  const [activeTab, setActiveTab] = useState(0);

  const caseStudies = [
    {
      category: 'Microsoft 365',
      title: 'Nonprofit Microsoft 365 Cleanup + Security Baseline',
      problem: 'Users had sharing sprawl and risky login settings.',
      solution: 'MFA enforcement, conditional access, SharePoint permissions cleanup, device policy baseline.',
      outcome: 'Reduced account risk and improved collaboration; simplified access for staff.',
      color: 'bg-blue-600',
    },
    {
      category: 'Network',
      title: 'Office Network Upgrade (Wi-Fi + Switching)',
      problem: 'Slow, unreliable Wi-Fi causing productivity issues and dropped video calls.',
      solution: 'Replaced consumer-grade equipment with enterprise access points and managed switches.',
      outcome: 'Reliable connectivity throughout the office; zero dropped calls since upgrade.',
      color: 'bg-cyan-500',
    },
    {
      category: 'Security',
      title: 'Backup + Disaster Recovery Setup',
      problem: 'No backup strategy; critical data at risk of ransomware or hardware failure.',
      solution: 'Implemented automated cloud backup with versioning and tested recovery procedures.',
      outcome: 'Peace of mind with verified backups; 4-hour recovery time objective achieved.',
      color: 'bg-blue-600',
    },
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <p className="text-sm font-semibold text-cyan-500 uppercase tracking-wide mb-2">
            Results
          </p>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Real Results for Real Businesses
          </h2>
          <p className="text-lg text-gray-600">See how we've helped organizations like yours</p>
        </div>

        {/* Tabs */}
        <div className="flex justify-center mb-8 space-x-4 flex-wrap gap-2">
          {caseStudies.map((study, index) => (
            <button
              key={index}
              onClick={() => setActiveTab(index)}
              className={`px-6 py-3 rounded-lg font-semibold transition-all duration-300 ${
                activeTab === index
                  ? 'bg-blue-600 text-white shadow-lg'
                  : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-200'
              }`}
            >
              {study.category}
            </button>
          ))}
        </div>

        {/* Content */}
        <Card className="max-w-4xl mx-auto border-none shadow-xl">
          <CardHeader>
            <Badge className={`${caseStudies[activeTab].color} text-white w-fit mb-4`}>
              {caseStudies[activeTab].category}
            </Badge>
            <CardTitle className="text-2xl font-bold text-gray-900">
              {caseStudies[activeTab].title}
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-6">
            <div>
              <h4 className="font-bold text-gray-900 mb-2">Problem:</h4>
              <p className="text-gray-600 leading-relaxed">{caseStudies[activeTab].problem}</p>
            </div>
            <div>
              <h4 className="font-bold text-gray-900 mb-2">What we did:</h4>
              <p className="text-gray-600 leading-relaxed">{caseStudies[activeTab].solution}</p>
            </div>
            <div>
              <h4 className="font-bold text-gray-900 mb-2">Outcome:</h4>
              <p className="text-gray-600 leading-relaxed">{caseStudies[activeTab].outcome}</p>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default ResultsSection;